import React from 'react';
import styled from 'styled-components';
import { useSignals } from '@preact/signals-react/runtime';
import { AiManifestComponent } from '@/pkg/ai';
import { useAiComponentContext } from '@/features/editor/widgets/ai-component/context';
import { GenericCssRuleInput } from '@/features/editor/widgets/ai-component/inputs/css/generic-css-rule-input';
import { GenericJsVariableInput } from '@/features/editor/widgets/ai-component/inputs/js/generic-js-variable-input';
import { GenericHtmlAttrInput } from '@/features/editor/widgets/ai-component/inputs/html-attr/generic-html-attr-input';
import { GenericHtmlContentInput } from '@/features/editor/widgets/ai-component/inputs/html-content/generic-html-content-input';
import { HtmlVideoInput } from '@/features/editor/widgets/ai-component/inputs/html-video/html-video-input';

export interface AiComponentGenericInputProps {
  component: AiManifestComponent;
}

export function AiComponentGenericInput({
  component,
}: AiComponentGenericInputProps) {
  useSignals();
  const getCssRule = useAiComponentContext((ctx) => ctx.getCssRule);
  const setCssRule = useAiComponentContext((ctx) => ctx.setCssRule);

  const getJsVariables = useAiComponentContext(
    (ctx) => ctx.getManifestVariables,
  );
  const setJsVariable = useAiComponentContext((ctx) => ctx.setVariable);

  const getHtmlAttribute = useAiComponentContext((ctx) => ctx.getAttribute);
  const setHtmlAttribute = useAiComponentContext((ctx) => ctx.setAttribute);
  const getHtmlTextContent = useAiComponentContext((ctx) => ctx.getTextContent);
  const setHtmlTextContent = useAiComponentContext((ctx) => ctx.setTextContent);
  const getHtmlContent = useAiComponentContext((ctx) => ctx.getHtmlContent);
  const setHtmlContent = useAiComponentContext((ctx) => ctx.setHtmlContent);
  const getVideoAttributes = useAiComponentContext(
    (ctx) => ctx.getVideoAttributes,
  );
  const setVideoAttributes = useAiComponentContext(
    (ctx) => ctx.setVideoAttributes,
  );

  return (
    <Wrapper className="ai-component-generic-input">
      {component.type === `css-rule` && (
        <GenericCssRuleInput
          component={component}
          setCssRule={setCssRule}
          getCssRule={getCssRule}
        />
      )}
      {component.type === `js-variable` && (
        <GenericJsVariableInput
          component={component}
          getJsVariables={getJsVariables}
          setJsVariable={setJsVariable}
        />
      )}
      {component.type === `html-attr` && (
        <GenericHtmlAttrInput
          component={component}
          getHtmlAttribute={getHtmlAttribute}
          setHtmlAttribute={setHtmlAttribute}
        />
      )}
      {component.type === `html-content` && (
        <GenericHtmlContentInput
          component={component}
          getHtmlContent={getHtmlContent}
          setHtmlContent={setHtmlContent}
          getTextContent={getHtmlTextContent}
          setTextContent={setHtmlTextContent}
        />
      )}
      {component.type === `html-video` && (
        <HtmlVideoInput
          component={component}
          setVideoAttributes={setVideoAttributes}
          getVideoAttributes={getVideoAttributes}
        />
      )}
    </Wrapper>
  );
}

const Wrapper = styled.div``;
